import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["width", "height"];
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M1.59998 6.17294V9.82862C1.59998 10.2881 1.59998 10.5178 1.66422 10.7257C1.72109 10.9096 1.81427 11.0803 1.93825 11.2276C2.07832 11.394 2.27157 11.5182 2.65807 11.7667L6.75407 14.3998L6.75408 14.3998C7.20533 14.6899 7.43096 14.835 7.67374 14.8915C7.88837 14.9414 8.11159 14.9414 8.32621 14.8915C8.56899 14.835 8.79462 14.6899 9.24588 14.3998L13.3419 11.7667C13.7284 11.5182 13.9216 11.394 14.0617 11.2276C14.1857 11.0803 14.2789 10.9096 14.3357 10.7257C14.4 10.5178 14.4 10.2881 14.4 9.82863V6.17294C14.4 5.71346 14.4 5.48372 14.3357 5.27591C14.2789 5.09196 14.1857 4.92129 14.0617 4.77398C13.9216 4.60756 13.7284 4.48333 13.3419 4.23486L9.24588 1.60172C8.79462 1.31162 8.56899 1.16658 8.32621 1.11011C8.11159 1.06018 7.88837 1.06018 7.67374 1.11011C7.43096 1.16658 7.20533 1.31163 6.75407 1.60172L2.65807 4.23486C2.27157 4.48333 2.07832 4.60756 1.93825 4.77398C1.81427 4.92129 1.72109 5.09196 1.66422 5.27591C1.59998 5.48372 1.59998 5.71346 1.59998 6.17294Z",
  fill: "#DB333B"
}, null, -1);
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M10.4 5.60156L5.59998 10.4016M5.59998 5.60156L10.4 10.4016",
  stroke: "white",
  "stroke-width": "1.336",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1);
const _hoisted_4 = [_hoisted_2, _hoisted_3];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: $props.width,
    height: $props.height,
    viewBox: "0 0 16 16",
    fill: "none"
  }, _hoisted_4, 8, _hoisted_1);
}